<template>
  <div class="page_container">
    <div class="page_header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>授权管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card class="page_card">
      <el-form class="search_form" size="small" @submit.native.prevent :inline="true">
        <el-form-item label="关键词">
          <el-input
            class="keyword_input"
            v-model="searchForm.keyWords"
            placeholder="激活码、硬件ID、订单编号、产品名称"
            @clear="handleClickSearch"
            @keyup.enter.native="handleClickSearch"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="操作记录">
          <el-input
            class="operation_record_input"
            v-model.trim="searchForm.operationRecord"
            placeholder="请输入激活码或硬件ID"
            maxlength="128"
            @clear="handleClickSearch"
            @keyup.enter.native="handleClickSearch"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item class="search_actions">
          <el-button type="primary" icon="el-icon-search" @click="handleClickSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleClickReset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table ref="table1" :data="tableData" style="width: 100%" :height="tableHeight">
        <el-table-column prop="id" align="center" label="编号" min-width="80"></el-table-column>
        <el-table-column prop="product_name" align="center" label="产品名称" min-width="140">
          <template slot-scope="{row}">
            <span class="template_color" @click="handleClickDetail(row)" v-if="row.product && row.product.product_name" v-text="row.product.product_name"></span>
          </template>
        </el-table-column>
        <el-table-column   prop="license_code"  align="center"  label="激活码"  width="180">
          <template slot-scope="{row}">
            <span class="tableLicenseCodeColumn" v-text="row.license_code"></span>
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="购买人" min-width="120">
          <template slot-scope="{row}">
            <span v-if="row.user && row.user.name" v-text="row.user.name"></span>
          </template>
        </el-table-column>
        <el-table-column prop="order_num" align="center" label="所属订单编号" min-width="150">
          <template slot-scope="{row}">
            <span v-if="row.order && row.order.order_num" v-text="row.order.order_num"></span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="配置状态" min-width="110">
          <template slot-scope="{row}">
            <el-tag v-if="row.is_custom_config" size="small" type="warning">单独配置</el-tag>
            <el-tag v-else size="small" type="success">订单配置</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="machine_id" align="center" label="当前状态" min-width="120">
          <template slot-scope="{row}">
            <!--              <span v-text="row.machine_id ? '已激活' : '未激活'"></span>-->
            <span v-if="!row.machine_id">未激活</span>
            <span v-else v-text="timeWarFunction(row.end_date) ? '已过期' : '已激活'"></span>
          </template>
        </el-table-column>
        <el-table-column prop="machine_id" align="center" label="硬件ID" min-width="560" show-overflow-tooltip></el-table-column>

        <el-table-column   prop="start_date"  align="center"  label="用户授权时间"  min-width="300">
          <template slot-scope="{row}">
            <span v-if="row.start_date" v-text="convertToCurrentTimezone(row.start_date,'/','datetime') +' ~ '+ convertToCurrentTimezone(row.end_date,'/','datetime')"></span>
          </template>
        </el-table-column>

        <el-table-column   prop="start_date"  align="center"  label="订单有效期"  min-width="300">
          <template slot-scope="{row}">
            <span v-if="row.order && row.order.start_date" v-text="convertToCurrentTimezone(row.order.start_date,'/','datetime') +' ~ '+ convertToCurrentTimezone(row.order.end_date,'/','datetime')"></span>
          </template>
        </el-table-column>
        <el-table-column   prop="date"  align="center"  label="软件到期时间"  min-width="160">
          <template slot-scope="{row}">
            <span v-if="row.client_end_date" v-text="convertToCurrentTimezone(row.client_end_date,'/','datetime')"></span>
          </template>
        </el-table-column>
        <el-table-column   prop="last_connection_time"  align="center"  label="上次连接时间"  min-width="160" show-overflow-tooltip	>
          <template slot-scope="{row}">
            <span v-if="row.last_connection_time" v-text="convertToCurrentTimezone(row.last_connection_time,'/','datetime')"></span>
          </template>
        </el-table-column>
        <el-table-column   prop="note"  align="center"  label="后台备注"  min-width="220" show-overflow-tooltip	>
          <template slot-scope="{row}">
            <span v-if="row.order" v-text="row.order.admin_note"></span>
          </template>
        </el-table-column>
        <el-table-column prop="date" align="center" label="操作" width="60"  fixed="right">
          <template slot-scope="{row}">
            <el-dropdown trigger="click" class="dropdown_more" >
              <i class="el-icon-more"></i>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="handleClickDetail(row)" >详情</el-dropdown-item>
                  <el-dropdown-item @click.native="handleClickLog(row)" >操作记录</el-dropdown-item>
                  <el-dropdown-item v-if="!row.license_code" @click.native="handleClickGenerateAuthCode(row)" >生成激活码</el-dropdown-item>
                  <el-dropdown-item v-if="row.license_code" @click.native="handleClickRetrieveAuthCode(row)" >回收激活码</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>


      </el-table>
      <el-pagination background
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="pagination.pageNum"
                     :page-sizes="pagination.pageSizes"
                     :page-size="pagination.pageSize"
                     :layout="pagination.layout"
                     :total="pagination.total">
      </el-pagination>
    </el-card>



    <generateAuthCode :generateAuthCodeVisible.sync="generateAuthCodeVisible" v-if="generateAuthCodeVisible" :licenseId="licenseId" :productName="productName"  @success="generateAuthCodeSuccess"/>
    <copyAuthCode :copyAuthCodeVisible.sync="copyAuthCodeVisible" v-if="copyAuthCodeVisible" :licenseCode="licenseCode" :productName="productName"  @success="handleClickSearch"/>
    <retrieveAuthCode :retrieveAuthCodeVisible.sync="retrieveAuthCodeVisible" v-if="retrieveAuthCodeVisible" :retrieveInfo="retrieveInfo"   @success="handleClickSearch"/>

    <productDetail :productDetailVisible.sync="productDetailVisible" v-if="productDetailVisible" :productId="productId" />
    <productLog :logVisible.sync="logVisible" v-if="logVisible" :productName="productName" :logId="logId"  />
  </div>
</template>

<script>
import {adminUserProductList } from '@/api/api'
import {getTableHeight,convertToCurrentTimezone} from '@/utils'
import {pagination} from '@/mixins'
import {mapState} from "vuex";
import generateAuthCode from '../individual_users/generate_auth_code.vue'
import copyAuthCode from '../individual_users/copy_auth_code.vue'
import retrieveAuthCode from '../individual_users/retrieve_auth_code.vue'
import productDetail from '../individual_users/product_detail.vue'
import productLog from '../individual_users/product_log.vue'
export default {
  name: 'auth_manage',
  components: {
    generateAuthCode,
    copyAuthCode,
    retrieveAuthCode,
    productDetail,
    productLog
  },
  data() {
    return {
      loading:false,
      tableData:[ ],
      tableHeight:'',
      searchForm:{
        keyWords:'',
        operationRecord:''
      },
      generateAuthCodeVisible:false,
      licenseId:0,
      productName:'',
      copyAuthCodeVisible:false,
      licenseCode:'',
      retrieveAuthCodeVisible:false,
      retrieveInfo:{},

      productDetailVisible:false,
      productId:0,
      logVisible:false,
      logId:0
    }
  },

  mixins: [pagination],
  created() {
    //将计算的table高度赋值给table
    this.tableHeight = getTableHeight(265)
  },
  mounted() {
    if(this.$route.params && this.$route.params.keyword){
      this.searchForm.keyWords = this.$route.params.keyword
    }
    this.getTableData()
    //窗口缩放时动态修改table的高度
    window.onresize = () => {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }
      //开启定时器，节流函数
      this.resizeTimer = setTimeout(() => {
        //将计算的table高度赋值给table
        this.tableHeight = getTableHeight(265)
        //清除定时器
        this.resizeTimer = null
      }, 100)
    }
  },
  computed: {
    ...mapState(['adminUserInfo']),
  },
  methods: {
    // 当前日期和授权结束日期比
    timeWarFunction(time){
      let rowTime =  this.convertToCurrentTimezone(time,'/','datetime')
      let currentTime = this.getCurrentDate()
      const date1 = new Date(rowTime);
      const date2 = new Date(currentTime);
      if(date1 < date2){
        return true
      }else{
        return  false
      }
    },

    getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear(); // 获取年份
      const month = now.getMonth() + 1; // 获取月份，月份从0开始，所以需要+1
      const day = now.getDate(); // 获取日期
      const hours = now.getHours(); // 获取小时
      const minutes = now.getMinutes(); // 获取分钟

      // 将单个数字格式化为两位数（例如，1 -> 01）
      const formatNumber = (num) => num < 10 ? '0' + num : num;

      // 组合成指定格式的字符串
      return `${year}/${formatNumber(month)}/${formatNumber(day)} ${formatNumber(hours)}:${formatNumber(minutes)}`;
    },

    convertToCurrentTimezone(utcTime,separator,type) {
      return convertToCurrentTimezone(utcTime,separator,type);
    },
    // 操作记录
    handleClickLog(row){
      this.productName = row.product ? row.product.product_name : ''
      this.logId = row.id
      this.logVisible = true
    },

    handleClickDetail(row){
      this.productId = row.id
      this.productDetailVisible = true
    },
    // 搜索
    handleClickSearch(){
      this.pagination.pageNum = 1
      this.getTableData()
    },
    // 重置
    handleClickReset(){
      this.searchForm.keyWords = ''
      this.searchForm.operationRecord = ''
      this.pagination.pageNum = 1
      this.getTableData()
    },

    // 生成激活码
    handleClickGenerateAuthCode(row){
      this.licenseId = row.id
      this.productName = row.product ? row.product.product_name : ''
      this.generateAuthCodeVisible = true
    },
    // 生成激活码之后的回调
    generateAuthCodeSuccess(data){
      this.productName = data.product_name
      this.licenseCode = data.license_code
      this.copyAuthCodeVisible = true
    },
    // 回收激活码
    handleClickRetrieveAuthCode(row){
      this.retrieveInfo = {
        license_id:row.id,
        license_code:row.license_code,
        product_name:row.product_name,
        end_date:row.end_date,
        status_text:!row.machine_id ? '未激活' :this.timeWarFunction(row.end_date) ?  '已过期' : '已激活'
      }
      this.retrieveAuthCodeVisible = true
    },
    // 获取数据
    getTableData() {
      this.loading = true
      let postData = {
        page: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        keyword:this.searchForm.keyWords,
        operation_record:this.searchForm.operationRecord
      }
      adminUserProductList(postData).then(res => {
        if (res.code === 200) {
          let {total, data} = res.data
          this.tableData = data
          this.pagination.total = total
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    handleSizeChange(val) {
      this.pagination.pageNum = 1
      this.pagination.pageSize = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val
      this.getTableData()
    },

  },
  watch: {

  },
}
</script>

<style scoped lang="scss">
.search_form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  column-gap: 8px;
}
.keyword_input {
  width: 280px;
}
.operation_record_input {
  width: 280px;
}
.search_actions {
  white-space: nowrap;
}
.tableLicenseCodeColumn{
  font-family: fangsong;
  color: #1c2127;
  font-size: 15px;
}
.el-form-item.align-items-center{
  display: flex;
  align-items: center;
}
.dropdown_more{
  cursor: pointer;
}

.el-icon-more{
  transform: rotate(90deg);
  cursor: pointer;
  vertical-align: middle;
}
.el-icon-more:hover{
  color: #1990ff;
}
.page_container .page_card {
  overflow-y: scroll;
  padding-bottom: 20px;
}
</style>
